var _defs, _g, _g2, _g3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDeadlines(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".d{fill:#801950;}.e{fill:none;stroke:#801950;stroke-linecap:round;stroke-miterlimit:10;stroke-width:25px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "a"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "b"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "e",
    x1: 256,
    y1: 167.05,
    x2: 256,
    y2: 90.67
  }), /*#__PURE__*/React.createElement("line", {
    className: "e",
    x1: 342.1,
    y1: 166.83,
    x2: 342.1,
    y2: 90.45
  }), /*#__PURE__*/React.createElement("line", {
    className: "e",
    x1: 171.5,
    y1: 167.15,
    x2: 171.5,
    y2: 90.77
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M418.99,123.56H93.01c-6.3,0-11.46,5.16-11.46,11.46V417.76c0,6.3,5.16,11.46,11.46,11.46H418.99c6.3,0,11.46-5.16,11.46-11.46V135.02c0-6.3-5.16-11.46-11.46-11.46ZM155.91,216.84h93.56c6.59,0,11.94,5.34,11.94,11.94s-5.34,11.94-11.94,11.94h-93.56c-6.59,0-11.94-5.34-11.94-11.94s5.34-11.94,11.94-11.94Zm94.25,152.02h-93.56c-6.59,0-11.94-5.34-11.94-11.94s5.34-11.94,11.94-11.94h93.56c6.59,0,11.94,5.34,11.94,11.94s-5.34,11.94-11.94,11.94Zm0-64.48h-93.56c-6.59,0-11.94-5.34-11.94-11.94s5.34-11.94,11.94-11.94h93.56c6.59,0,11.94,5.34,11.94,11.94s-5.34,11.94-11.94,11.94Zm117.35-29.33l-55.4,49.96-19.57-26.13c-3.95-5.28-2.88-12.76,2.4-16.71,5.28-3.95,12.76-2.88,16.71,2.4l3.89,5.2,35.98-32.44c4.9-4.42,12.44-4.03,16.86,.87,4.41,4.9,4.03,12.44-.87,16.86Zm.03-67.24l-55.4,49.96-19.57-26.13c-3.95-5.28-2.88-12.76,2.4-16.71,5.28-3.95,12.76-2.88,16.71,2.4l3.89,5.2,35.98-32.44c4.9-4.42,12.44-4.03,16.86,.87s4.03,12.44-.87,16.86Z"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "c"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeadlines);
export default __webpack_public_path__ + "static/media/deadlines.0786cac39f8cdeb44b48ad488ed6c2cd.svg";
export { ForwardRef as ReactComponent };